/**
 * @generated SignedSource<<24e19b3b6ca779f0c596994629647453>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectWalletWithSigningNoZipContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "ConnectWalletWithSigningNoZipContent_viewer";
};
export type ConnectWalletWithSigningNoZipContent_viewer$key = {
  readonly " $data"?: ConnectWalletWithSigningNoZipContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectWalletWithSigningNoZipContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectWalletWithSigningNoZipContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "27bf7e6a401a34bc7832dd50c11dcc2d";

export default node;
